import Vue from 'vue'

// 全局事件总线：挂载到根组件 data.eventHub（main.js 引用同一实例），
// 供 store 内 action 与各组件 this.$root.eventHub 通信
export default new Vue()
